export const BASE_URL_CARTOONS = 'https://api.sampleapis.com/cartoons/cartoons2D'
export const BASE_URL_SIMPSONS = 'https://thesimpsonsquoteapi.glitch.me'
export const BASE_URL_RICKMORTY = 'https://rickandmortyapi.com/api'
